"use strict";
(function () {

  var COLORS = [
    { rgb:'rgb(255,255,255)', name:'Bright White'      },
    { rgb:'rgb(255,141,2)',   name:'Orange Soda'       },
    { rgb:'rgb(0,0,255)',     name:'Army Blue'         },
    { rgb:'rgb(255,192,203)', name:'Winky Pink'        },
    { rgb:'rgb(128,0,128)',   name:'Purple Slurple'    },
    { rgb:'rgb(255,255,0)',   name:'Pikachu Yellow'    },
    { rgb:'rgb(0,255,0)',     name:'Green Smoothie'    },
    { rgb:'rgb(173,216,230)', name:'Ice Ice Baby Blue' },
    { rgb:'rgb(255,0,0)',     name:'Police Red'        },
    { rgb:'rgb(230,58,148)',  name:'Flamingo Pop'      },
    { rgb:'rgb(255,245,182)', name:'Vanilla Glow'      },
    { rgb:'rgb(231,174,33)',  name:'Golden Hour'       },
  ];

  function waitFor(cb) {
    if (typeof NeonCustomizer !== 'undefined' &&
        NeonCustomizer.elements &&
        NeonCustomizer.elements.preview) { cb(); }
    else { setTimeout(function(){ waitFor(cb); }, 50); }
  }

  waitFor(function () {

    var preview   = NeonCustomizer.elements.preview;
    var container = NeonCustomizer.elements.container;

    var active     = false;
    var hasColours = false;
    var selSpan    = null;
    var colorStore = {};
    var palOpenTime = 0;
    var wrapping   = false;
    var observer;

    NeonCustomizer.state._isMulticolor = false;

    var s = document.createElement('style');
    s.textContent = [
      '.mc-wrap{position:absolute;left:12px;top:120px;z-index:15;display:flex;align-items:center;}',
      '@media(min-width:769px){.mc-wrap{top:130px;}}',
      '@media(max-width:1024px){.mc-wrap{top:110px;left:10px;}}',
      '@media(max-width:768px){.mc-wrap{top:100px;left:8px;}}',
      '@media(max-width:480px){.mc-wrap{top:90px;left:6px;}}',
      '.mc-btn{width:50px;height:50px;border-radius:50%;cursor:pointer;flex-shrink:0;',
        'background:rgba(220,235,242,0.72);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);',
        'border:2px solid rgba(44,95,125,0.35);',
        'box-shadow:0 4px 16px rgba(44,95,125,0.14),0 1px 4px rgba(44,95,125,0.10),inset 0 1px 0 rgba(255,255,255,0.65);',
        'transition:transform 0.2s cubic-bezier(.34,1.56,.64,1);touch-action:manipulation;',
        'display:flex;align-items:center;justify-content:center;outline:none;}',
      '.mc-btn:hover{transform:translateY(-3px) scale(1.06);border-color:rgba(155,89,182,0.55);background:rgba(155,89,182,0.10);}',
      '.mc-btn.on{border-color:rgba(155,89,182,0.85)!important;background:rgba(155,89,182,0.22)!important;animation:mc-ring 2s ease-in-out infinite;}',
      '@keyframes mc-ring{0%,100%{box-shadow:0 0 0 4px rgba(155,89,182,0.2),0 6px 20px rgba(155,89,182,0.3);}50%{box-shadow:0 0 0 6px rgba(155,89,182,0.1),0 6px 20px rgba(155,89,182,0.35);}}',
      '.mc-btn svg{width:22px;height:22px;pointer-events:none;}',
      '@media(max-width:768px){.mc-btn{width:38px;height:38px;}.mc-btn svg{width:18px;height:18px;}}',
      '.mc-tip{position:absolute;left:calc(100% + 10px);top:50%;transform:translateY(-50%) scale(0.95);',
        'background:rgba(155,89,182,0.9);color:#fff;padding:6px 12px;border-radius:12px;',
        'font-size:12px;font-weight:700;font-family:"Solway",serif;white-space:nowrap;',
        'opacity:0;pointer-events:none;transition:opacity 0.2s,transform 0.2s;z-index:10;}',
      '.mc-tip::before{content:"";position:absolute;right:100%;top:50%;transform:translateY(-50%);border:5px solid transparent;border-right-color:rgba(155,89,182,0.9);}',
      '.mc-wrap:hover .mc-tip{opacity:1;transform:translateY(-50%) translateX(4px) scale(1);}',
      '.mc-hint{position:absolute;top:8px;left:50%;transform:translateX(-50%);font-family:"Solway",serif;font-size:12px;font-weight:700;color:#fff;background:rgba(155,89,182,0.85);padding:5px 14px;border-radius:999px;pointer-events:none;z-index:16;white-space:nowrap;opacity:0;transition:opacity .3s;}',
      '.mc-hint.on{opacity:1;}',
      '.mc-active{font-size:0!important;}',
      '.mc-letter{font-size:var(--mc-fs,inherit)!important;font-family:inherit!important;font-weight:inherit!important;line-height:inherit!important;letter-spacing:0!important;word-spacing:0!important;display:inline!important;border-radius:2px;}',
      '.mc-active .mc-letter{cursor:crosshair;}',
      '.mc-letter.sel{background:rgba(255,255,255,0.18);outline:2px solid rgba(255,255,255,0.6);outline-offset:1px;border-radius:3px;}',
      '.mc-pal{position:fixed;background:linear-gradient(135deg,rgba(220,235,242,0.97),rgba(215,232,240,0.95));backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border:1.5px solid rgba(44,95,125,0.3);border-radius:20px;padding:14px;box-shadow:0 16px 48px rgba(44,95,125,0.22),0 4px 12px rgba(44,95,125,0.12),inset 0 1px 0 rgba(255,255,255,0.7);z-index:2147483647;display:none;flex-direction:column;gap:10px;min-width:196px;}',
      '.mc-pal.on{display:flex;}',
      '.mc-pal::before{content:"";position:absolute;bottom:100%;left:20px;border:7px solid transparent;border-bottom-color:rgba(44,95,125,0.3);}',
      '.mc-pal::after{content:"";position:absolute;bottom:100%;left:21px;border:6px solid transparent;border-bottom-color:rgba(220,235,242,0.97);}',
      '.mc-pal.above::before{bottom:auto;top:100%;border-bottom-color:transparent;border-top-color:rgba(44,95,125,0.3);}',
      '.mc-pal.above::after{bottom:auto;top:100%;left:21px;border-bottom-color:transparent;border-top-color:rgba(220,235,242,0.97);}',
      '.mc-pal-title{font-family:"Solway",serif;font-size:0.75rem;font-weight:800;text-transform:uppercase;letter-spacing:1.8px;color:#2c5f7d;text-align:center;padding-bottom:8px;border-bottom:1.5px solid rgba(44,95,125,0.14);}',
      '.mc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;justify-items:center;padding:2px 0;}',
      '.mc-sw{width:36px;height:36px;border-radius:50%;cursor:pointer;border:3px solid rgba(255,255,255,0.45);box-shadow:0 3px 10px rgba(44,95,125,0.2);transition:transform .15s cubic-bezier(.34,1.56,.64,1);outline:none;}',
      '.mc-sw:hover{transform:scale(1.22);}',
      '.mc-sw.on{border-color:rgba(255,255,255,0.95)!important;transform:scale(1.15);box-shadow:0 0 0 3px rgba(44,95,125,0.28)!important;}',
      '.mc-reset{font-family:"Solway",serif;font-size:0.78rem;font-weight:800;color:#2c5f7d;background:rgba(44,95,125,0.08);border:1.5px solid rgba(44,95,125,0.25);border-radius:999px;padding:7px 14px;cursor:pointer;text-align:center;transition:background .15s,transform .15s;width:100%;}',
      '.mc-reset:hover{background:rgba(44,95,125,0.16);transform:translateY(-1px);}',
      '.mc-badge{display:inline-flex;align-items:center;gap:4px;font-size:.82em;font-weight:700;padding:3px 10px;border-radius:999px;background:linear-gradient(135deg,rgba(255,107,157,.2),rgba(155,89,182,.2));border:1.5px solid rgba(155,89,182,.45);color:#2e0a50;vertical-align:middle;}',
    ].join('');
    document.head.appendChild(s);

    var wrap = document.createElement('div');
    wrap.className = 'mc-wrap';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mc-btn';
    btn.setAttribute('aria-label', 'Toggle multicolor mode');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#9b59b6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>';
    var tip = document.createElement('span');
    tip.className = 'mc-tip'; tip.textContent = 'Multicolor';
    wrap.appendChild(btn); wrap.appendChild(tip);
    container.appendChild(wrap);

    var hint = document.createElement('div');
    hint.className = 'mc-hint';
    hint.textContent = '✦ Tap any letter to colour it';
    container.appendChild(hint);
    var hintTimer;

    var pal = document.createElement('div');
    pal.className = 'mc-pal';
    pal.innerHTML = '<div class="mc-pal-title">Pick a colour</div><div class="mc-grid"></div><button type="button" class="mc-reset">↩ Reset this letter</button>';
    document.body.appendChild(pal);

    var gridEl = pal.querySelector('.mc-grid');
    COLORS.forEach(function(c) {
      var sw = document.createElement('button');
      sw.type = 'button'; sw.className = 'mc-sw'; sw.title = c.name;
      sw.dataset.rgb = c.rgb; sw.style.background = c.rgb;
      if (c.rgb === 'rgb(255,255,255)') sw.style.borderColor = 'rgba(100,140,180,0.45)';
      gridEl.appendChild(sw);
    });

    function gc() { return NeonCustomizer.state.selectedColor || 'rgb(255,255,255)'; }

    function applyStyle(el, rgb) {
      el.style.color = 'color-mix(in srgb,white 55%,' + rgb + ' 45%)';
      el.style.textShadow = '0 0 3px '+rgb+',0 0 6px '+rgb+',0 0 15px '+rgb+',0 0 20px '+rgb;
    }

    function plainText() {
      return (preview.textContent || '').replace(/[\u200B-\u200F\uFEFF]/g, '');
    }

    function observerStop() { if (observer) observer.disconnect(); }

    function observerStart() {
      lastPlainText = plainText();
      observer.observe(preview, { childList: true, subtree: true, characterData: true });
    }

    function wrapLetters() {
      wrapping = true;
      observerStop();

      preview.classList.remove('mc-active');
      var fs = getComputedStyle(preview).fontSize;
      preview.style.setProperty('--mc-fs', fs);

      var saved = Object.assign({}, colorStore);
      preview.querySelectorAll('.mc-letter').forEach(function(sp) {
        if (sp.dataset.charIndex != null && sp.dataset.color)
          saved[sp.dataset.charIndex] = sp.dataset.color;
      });

      var walker = document.createTreeWalker(preview, NodeFilter.SHOW_TEXT);
      var nodes = []; var n;
      while ((n = walker.nextNode())) nodes.push(n);

      var idx = 0;
      nodes.forEach(function(tn) {
        var frag = document.createDocumentFragment();
        Array.from(tn.textContent).forEach(function(ch) {
          if (ch === '\n' || ch === '\r') { frag.appendChild(document.createTextNode(ch)); return; }
          var sp = document.createElement('span');
          sp.className = 'mc-letter';
          sp.dataset.charIndex = String(idx);
          sp.textContent = ch;
          var col = saved[String(idx)] || gc();
          if (saved[String(idx)]) sp.dataset.color = col;
          applyStyle(sp, col);
          frag.appendChild(sp);
          idx++;
        });
        tn.parentNode.replaceChild(frag, tn);
      });

      preview.classList.add('mc-active');
      hasColours = true;
      wrapping = false;
    }

    function unwrapLetters() {
      wrapping = true;
      observerStop();

      preview.querySelectorAll('.mc-letter').forEach(function(sp) {
        if (sp.dataset.charIndex != null && sp.dataset.color)
          colorStore[sp.dataset.charIndex] = sp.dataset.color;
        sp.parentNode.replaceChild(document.createTextNode(sp.textContent), sp);
      });
      preview.normalize();
      preview.classList.remove('mc-active');
      preview.style.removeProperty('--mc-fs');
      hasColours = false;
      wrapping = false;
    }

    function openPal(span) {
      if (selSpan) selSpan.classList.remove('sel');
      selSpan = span; selSpan.classList.add('sel');
      var cur = span.dataset.color || gc();
      pal.querySelectorAll('.mc-sw').forEach(function(sw) {
        sw.classList.toggle('on', sw.dataset.rgb === cur);
      });
      pal.classList.remove('above'); pal.classList.add('on');
      palOpenTime = Date.now();
      requestAnimationFrame(function() {
        var r = span.getBoundingClientRect();
        var pw = pal.offsetWidth||200, ph = pal.offsetHeight||180;
        var top, above = false;
        if (r.bottom + 10 + ph <= window.innerHeight - 8) { top = r.bottom + 10; }
        else { top = r.top - 10 - ph; above = true; }
        pal.classList.toggle('above', above);
        var left = r.left;
        if (left + pw > window.innerWidth - 8) left = window.innerWidth - pw - 8;
        if (left < 8) left = 8;
        pal.style.top = top + 'px'; pal.style.left = left + 'px';
      });
    }

    function closePal() {
      pal.classList.remove('on');
      if (selSpan) { selSpan.classList.remove('sel'); selSpan = null; }
    }

    function applyColor(span, rgb) {
      span.dataset.color = rgb;
      colorStore[span.dataset.charIndex] = rgb;
      applyStyle(span, rgb);
      pal.querySelectorAll('.mc-sw').forEach(function(sw) {
        sw.classList.toggle('on', sw.dataset.rgb === rgb);
      });
    }

    function activate() {
      active = true; NeonCustomizer.state._isMulticolor = true;
      btn.classList.add('on'); hint.classList.add('on');
      preview.setAttribute('contenteditable', 'false');
      wrapLetters();
      observerStart();
      clearTimeout(hintTimer);
      hintTimer = setTimeout(function() { hint.classList.remove('on'); }, 3500);
    }

    function deactivate() {
      active = false; NeonCustomizer.state._isMulticolor = false;
      btn.classList.remove('on'); hint.classList.remove('on');
      clearTimeout(hintTimer);
      closePal();
      observerStop();
      // Save colours to store, keep spans visible so colours persist
      preview.querySelectorAll('.mc-letter').forEach(function(sp) {
        if (sp.dataset.charIndex != null && sp.dataset.color)
          colorStore[sp.dataset.charIndex] = sp.dataset.color;
        sp.classList.remove('sel');
      });
      preview.setAttribute('contenteditable', 'true');
    }

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (active) deactivate(); else activate();
    });

    preview.addEventListener('click', function(e) {
      if (!active) return;
      var sp = e.target.closest('.mc-letter');
      if (!sp) { closePal(); return; }
      e.stopPropagation();
      if (selSpan === sp && pal.classList.contains('on')) { closePal(); return; }
      openPal(sp);
    });

    document.addEventListener('click', function(e) {
      if (!pal.classList.contains('on')) return;
      if (Date.now() - palOpenTime < 200) return;
      if (pal.contains(e.target)) return;
      if (e.target.closest('.mc-letter')) return;
      closePal();
    });

    gridEl.addEventListener('click', function(e) {
      var sw = e.target.closest('.mc-sw');
      if (!sw || !selSpan) return;
      e.stopPropagation();
      applyColor(selSpan, sw.dataset.rgb);
    });

    pal.querySelector('.mc-reset').addEventListener('click', function(e) {
      e.stopPropagation();
      if (!selSpan) return;
      delete selSpan.dataset.color;
      delete colorStore[selSpan.dataset.charIndex];
      applyStyle(selSpan, gc());
      pal.querySelectorAll('.mc-sw').forEach(function(sw) { sw.classList.remove('on'); });
      closePal();
    });

    preview.addEventListener('keydown', function(e) {
      if (!active) return;
      if (e.key !== 'Escape') { e.preventDefault(); e.stopPropagation(); }
    });
    preview.addEventListener('mousedown', function(e) { if (active) e.stopPropagation(); });
    preview.addEventListener('touchstart', function(e) { if (active) e.stopPropagation(); }, { passive: true });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closePal(); if (active) deactivate(); }
    });

    // When user types after exiting: clear store (indices invalid) and unwrap
    preview.addEventListener('keydown', function(e) {
      if (active) return;
      var isEditing = e.key.length === 1 || e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Enter';
      if (!isEditing) return;
      if (hasColours) { colorStore = {}; unwrapLetters(); }
    });

    var rewrapTimer;
    var lastPlainText = '';

    observer = new MutationObserver(function() {
      if (wrapping || !active) return;
      var cur = plainText();
      if (cur === lastPlainText) return;
      lastPlainText = cur;
      clearTimeout(rewrapTimer);
      rewrapTimer = setTimeout(function() {
        var selIdx = selSpan ? selSpan.dataset.charIndex : null;
        wrapLetters();
        if (selIdx !== null && pal.classList.contains('on')) {
          var restored = preview.querySelector('.mc-letter[data-char-index="' + selIdx + '"]');
          if (restored) { selSpan = restored; selSpan.classList.add('sel'); openPal(selSpan); }
          else closePal();
        }
        observerStart();
      }, 150);
    });

    // Patch getReviewData so the review list shows clean text, not col: encoding
    var _origReviewData = NeonCustomizer.getReviewData.bind(NeonCustomizer);
    NeonCustomizer.getReviewData = function() {
      var data = _origReviewData();
      // Clean the Text field — strip col: tokens to plain text
      if (data['Text'] && data['Text'].includes('col:')) {
        data['Text'] = data['Text'].replace(/col:\d+,\d+,\d+:[^|c]*/g, function(m) {
          var colon = m.lastIndexOf(':');
          if (colon < 0) return '';
          try { return decodeURIComponent(m.substr(colon + 1)); } catch(e) { return ''; }
        });
      }
      return data;
    };

    var _origLines = NeonCustomizer.getVisualLines.bind(NeonCustomizer);
    NeonCustomizer.getVisualLines = function(el) {
      var spans = el.querySelectorAll('.mc-letter');
      if (!spans.length) return _origLines(el);
      var g = gc(), result = '', line = '';
      function encSpan(sp) {
        var ch = sp.textContent, col = sp.dataset.color;
        if (!col || col === g) return ch;
        var nums = col.match(/\d+/g);
        if (!nums || nums.length < 3) return ch;
        return 'col:' + nums[0] + ',' + nums[1] + ',' + nums[2] + ':' + encodeURIComponent(ch);
      }
      function walk(node) {
        if (node.nodeType === 3) { line += node.textContent; return; }
        if (node.nodeName === 'BR') { result += line.trimEnd() + '|'; line = ''; return; }
        if (node.classList && node.classList.contains('mc-letter')) { line += encSpan(node); return; }
        Array.from(node.childNodes).forEach(walk);
      }
      Array.from(el.childNodes).forEach(walk);
      if (line.trimEnd()) result += line.trimEnd();
      return result.replace(/\|+$/, '') || '';
    };

    function restore() {
      var raw = plainText();
      if (!raw.includes('col:')) return;
      var g = gc(), lines = raw.split('|');
      preview.innerHTML = '';
      preview.classList.remove('mc-active');
      var fs = getComputedStyle(preview).fontSize;
      preview.style.setProperty('--mc-fs', fs);
      var ci = 0;
      lines.forEach(function(line, li) {
        var i = 0;
        while (i < line.length) {
          if (line.substr(i, 4) === 'col:') {
            var rest = line.substr(i + 4);
            var r1 = rest.indexOf(','), r2 = rest.indexOf(',', r1+1), r3 = rest.indexOf(':', r2+1);
            if (r1 < 0 || r2 < 0 || r3 < 0) { i++; continue; }
            var after = rest.substr(r3 + 1), nc = after.indexOf('col:');
            var enc = nc >= 0 ? after.substring(0, nc) : after;
            var ch = decodeURIComponent(enc);
            var rgb = 'rgb(' + rest.substring(0,r1) + ',' + rest.substring(r1+1,r2) + ',' + rest.substring(r2+1,r3) + ')';
            var sp = document.createElement('span');
            sp.className = 'mc-letter'; sp.dataset.charIndex = String(ci);
            sp.dataset.color = rgb; sp.textContent = ch;
            colorStore[String(ci)] = rgb; applyStyle(sp, rgb);
            preview.appendChild(sp); ci++;
            i += 4 + r3 + 1 + enc.length;
          } else {
            var c = line[i];
            if (c && c !== '\u200B') {
              var sp2 = document.createElement('span');
              sp2.className = 'mc-letter'; sp2.dataset.charIndex = String(ci);
              sp2.textContent = c; applyStyle(sp2, g);
              preview.appendChild(sp2); ci++;
            }
            i++;
          }
        }
        if (li < lines.length - 1) preview.appendChild(document.createElement('br'));
      });
      preview.classList.add('mc-active');
      hasColours = true; active = true; NeonCustomizer.state._isMulticolor = true;
      btn.classList.add('on'); hint.classList.add('on');
      preview.setAttribute('contenteditable', 'false');
      observerStart();
    }

    window.restoreMulticolorNow = restore;
    setTimeout(function() { if (plainText().includes('col:')) restore(); }, 500);

  });
})();